var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from "@brushfire/ui";
import { useContext } from "react";
import Constants from "../../../data/constants";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { putAttendeeGroup } from "../../../data/api";
import { useDispatch } from "react-redux";
import { handleErrors } from "../../../data/helpers";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { AppFormContext } from "../../../App";
var MyAttendeeDonate = function (_a) {
    var eventData = _a.eventData, attendee = _a.attendee, path = _a.path, setConfirmationMessage = _a.setConfirmationMessage, refreshAttendeeList = _a.refreshAttendeeList, order = _a.order, group = _a.group;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var formikContext = useContext(AppFormContext).formikContext;
    var onSubmit = function (values, formikHelpers, setGlobalError) {
        putAttendeeGroup(attendee.id, {
            groupId: null,
            joinCode: "",
        })
            .then(function (_a) {
            var _b, _c;
            var data = _a.data;
            if (data) {
                refreshAttendeeList();
                formikHelpers.setSubmitting(false);
                setConfirmationMessage({
                    title: "You're all set!",
                    subtitle: "You are no longer a part of a group",
                });
                history.push(Constants.Routes.myAttendee
                    .replace(":clientKey", eventData.clientKey)
                    .replace(":urlKey", eventData.urlKey)
                    .replace(Constants.Regex.guid, "")
                    .replace(":attendeeId", attendee.id)
                    .replace(":orderId", (_b = order === null || order === void 0 ? void 0 : order.id) !== null && _b !== void 0 ? _b : "")
                    .replace(":groupId", (_c = group === null || group === void 0 ? void 0 : group.id) !== null && _c !== void 0 ? _c : "")
                    .replace(":eventNumber", eventData.eventNumber.toString()));
            }
        })
            .catch(function (err) {
            handleErrors(err, dispatch, formikContext, setGlobalError);
        })
            .finally(function () {
            formikHelpers.setSubmitting(false);
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, formikBagProps: {
                    submitButtonLabel: "Leave Group",
                }, useUnsavedPrompt: false }, { children: function (_a) {
                    var formikContext = _a.formikContext;
                    return (_jsx(_Fragment, { children: _jsx(WidgetFieldset, { children: _jsx("div", __assign({ className: "pos-relative" }, { children: _jsx(FormikContextListener, { currentPath: path, path: [Constants.Routes.myAttendeeGroupLeave], formikContext: formikContext, active: true, initialValues: {}, focusDelay: 500 }) })) }) }));
                } })), _jsx("p", __assign({ className: "bold" }, { children: "Are you sure you want to leave this group?" })), _jsx("p", { children: "You can always join this group or another group later." })] }));
};
export default MyAttendeeDonate;
